module.exports = __webpack_public_path__ + "static/media/cheellart-profile-pic.c143a75b.png";